import { Fragment } from 'react';

type VehicleEnvkvLineProps = {
    parts: string[];
    className?: string;
};

/**
 * The Pkw-EnVKV short line. Each value wraps as a unit with its separator at
 * the line end; only a value wider than the whole line breaks inside.
 */
export function VehicleEnvkvLine({ parts, className }: VehicleEnvkvLineProps) {
    if (!parts.length) return null;

    return (
        <p className={className}>
            {parts.map((part, index) => (
                <Fragment key={part}>
                    {index > 0 ? ' ' : null}
                    <span className="inline-block">{index < parts.length - 1 ? `${part} ·` : part}</span>
                </Fragment>
            ))}
        </p>
    );
}
